Shopify.MobileMenu = {};

Shopify.MobileMenu = function (container) {
  this.container = document.querySelector('#menu-drawer');

  // this.mobileMenuContainer = this.container.querySelector('.mobile-menu-inner');

  this.fetchSection('/?view=sections&sections=header', container);

};

Shopify.MobileMenu.prototype = {

  fetchSection: function (sectionUrl, container) {
    var self = this;

    var pageUrl = window.location.hostname;
    pageUrl = pageUrl.split('?')[0];

    fetch('https://' + pageUrl + sectionUrl).then(function (response) {
      return response.text();
    }).then(function (data) {
      var parser = new DOMParser();
      var results = JSON.parse(data);
      var docElement = parser.parseFromString(results['header'], 'text/html');
      self.appendMenus(docElement);


    }).catch(function (err) {
      console.warn('Something went wrong.', err);
    });
  },

  appendMenus: function (sectionHtml) {
    var self = this;
    var mobileMenu = sectionHtml.querySelector('.js-mobile-menu');
    self.container.innerHTML = mobileMenu.innerHTML;
    customElements.define('header-drawer', HeaderDrawer);

    document.querySelectorAll(".menu-drawer__close-btn").forEach((button) => {
        button.addEventListener('click', (ev) => {
            
            document.querySelector('.shopify-section.section-header').classList.remove('menu-open');
            document.querySelector('body').classList.remove('overflow-hidden-tablet');
            document.querySelectorAll('.menu-drawer__close-btn').forEach((btn) => {
                if(btn.closest('details')){
                    btn.closest('details').removeAttribute('open');
                    btn.closest('details').classList.remove('menu-opening');
                    btn.closest('details').querySelector('summary').setAttribute('aria-expanded', 'false');
                }
                if(btn.closest('ul')){
                    btn.closest('ul').classList.remove('submenu-open');
                }
            });
        });
    })
  },

};


// class HeaderDrawer extends MenuDrawer {
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.querySelector('html').classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}


new Shopify.MobileMenu();

